/**
 * Hooks spécialisés pour les permissions sur les emprunts
 */
import { useMemo } from 'react';
import { useMultipleAuthorizations } from './useAuthorization';
import { ActionType, ModelType } from '@constants/authorization';

/**
 * Hook pour toutes les permissions sur un emprunt
 */
export const useBorrowingPermissions = (borrowingId) => {
  const checks = useMemo(() => {
    if (!borrowingId) return [];

    return [
      { key: 'canReturn', action: ActionType.RETURN, modelType: ModelType.BORROWING, modelId: borrowingId },
      { key: 'canUpdate', action: ActionType.UPDATE, modelType: ModelType.BORROWING, modelId: borrowingId },
      { key: 'canDelete', action: ActionType.DELETE, modelType: ModelType.BORROWING, modelId: borrowingId },
      { key: 'canValidate', action: ActionType.VALIDATE_RESERVATION, modelType: ModelType.BORROWING, modelId: borrowingId }
    ];
  }, [borrowingId]);

  const { permissions, loading, error, refresh } = useMultipleAuthorizations(checks);

  return {
    permissions: {
      canReturn: permissions.canReturn || false,
      canUpdate: permissions.canUpdate || false,
      canDelete: permissions.canDelete || false,
      canValidate: permissions.canValidate || false
    },
    loading,
    error,
    refresh
  };
};

/**
 * Hook pour les permissions de liste des emprunts (permissions générales)
 */
export const useBorrowingListPermissions = () => {
  const checks = useMemo(() => [
    { key: 'canViewAll', action: ActionType.READ, modelType: ModelType.BORROWING }
  ], []);

  const { permissions, loading, error, refresh } = useMultipleAuthorizations(checks);

  return {
    canViewAll: permissions.canViewAll || false,
    loading,
    error,
    refresh
  };
};
